import { useReactFlow } from '@xyflow/react';
import type { NodeSettingsProps } from '../../types';
import { useFlowDisplayLanguage } from '../../displayLanguage';

export function KeywordSwitchSettings({ node }: NodeSettingsProps<'keywordSwitch'>) {
  const { updateNodeData } = useReactFlow();
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <div className="space-y-4">
      <label className="block" data-product-tour="card-input-1">
        <span className="mb-1 block text-sm font-medium text-slate-700">
          {displayLanguage === 'en' ? 'keyword 1' : 'キーワード1'}
        </span>
        <input
          type="text"
          maxLength={200}
          value={typeof node.data.keyword1 === 'string' ? node.data.keyword1 : ''}
          onChange={(event) => updateNodeData(node.id, { keyword1: event.target.value })}
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-teal-400"
        />
      </label>
      <label className="block" data-product-tour="card-input-2">
        <span className="mb-1 block text-sm font-medium text-slate-700">
          {displayLanguage === 'en' ? 'keyword 2' : 'キーワード2'}
        </span>
        <input
          type="text"
          maxLength={200}
          value={typeof node.data.keyword2 === 'string' ? node.data.keyword2 : ''}
          onChange={(event) => updateNodeData(node.id, { keyword2: event.target.value })}
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-teal-400"
        />
      </label>
    </div>
  );
}
